import React from "react";
import { Spin, Tooltip } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

import "./ImagePreviews.scss";

const ImagePreview = React.memo(({ src, isDeleting, onRemove }) => {
   const isPreviewOnly = !onRemove;

   const modifierClass = isPreviewOnly ? "image-preview--preview-only" : "";
   const blockClassName = `image-preview ${modifierClass}`;

   return (
      <>
         {src && (
            <div className={blockClassName}>
               <img src={src} alt="Question preview" className="image-preview__image" />

               {onRemove && (
                  <>
                     <Tooltip title="If you click the button to remove the image, it will be removed permanently!">
                        {isDeleting ? (
                           <Spin className="image-preview__spin" spinning={isDeleting}></Spin>
                        ) : (
                           <div
                              className="image-preview__remove-btn"
                              role="button"
                              onClick={() => onRemove(src)}
                           >
                              <DeleteOutlined />
                           </div>
                        )}
                     </Tooltip>
                  </>
               )}
            </div>
         )}
      </>
   );
});

export default ImagePreview;
